module.exports = __webpack_public_path__ + "media/images/emblems/Bougy-Villars-coat_of_arms-40d7fb9b7f0ab0a4ea3c4109c90955d3.svg";